// src/components/forms/IncidentInformation.jsx
import React from 'react';
import {
    Box,
    Grid,
    TextField,
    Typography,
    MenuItem,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

const COUNTIES = [
    'Select One',
    'Abbeville',
    'Aiken',
    'Allendale',
    'Anderson',
    'Bamberg',
    'Barnwell',
    'Beaufort',
    'Berkeley',
    'Calhoun',
    'Charleston',
    'Cherokee',
    'Chester',
    'Chesterfield',
    'Clarendon',
    'Colleton',
    'Darlington',
    'Dillon',
    'Dorchester',
    'Edgefield',
    'Fairfield',
    'Florence',
    'Georgetown',
    'Greenville',
    'Greenwood',
    'Hampton',
    'Horry',
    'Jasper',
    'Kershaw',
    'Lancaster',
    'Laurens',
    'Lee',
    'Lexington',
    'McCormick',
    'Marion',
    'Marlboro',
    'Newberry',
    'Oconee',
    'Orangeburg',
    'Pickens',
    'Richland',
    'Saluda',
    'Spartanburg',
    'Sumter',
    'Union',
    'Williamsburg',
    'York',
];

export default function IncidentInformation() {
    const theme = useTheme();

    return (
        <Box mb={4}>
            {/* SC DPH�branded gradient header */}
            <Box
                sx={{
                    mb: 2,
                    p: 1,
                    borderRadius: 1,
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                }}
            >
                <Typography variant="h6" color="white">
                    Incident Information
                </Typography>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        select
                        label="County Where Incident Occurred"
                        fullWidth
                        defaultValue="Select One"
                    >
                        {COUNTIES.map((county) => (
                            <MenuItem key={county} value={county}>
                                {county}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={3}>
                    <TextField
                        label="Incident Date"
                        type="date"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={12} sm={3}>
                    <TextField
                        label="Incident Time"
                        type="time"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ step: 300 }} // optional: 5-min increments
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField label="Address / Location of Incident" fullWidth />
                </Grid>

                <Grid item xs={12} sm={3}>
                    <TextField label="City" fullWidth />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <TextField label="State" defaultValue="SC" fullWidth />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <TextField label="Zip" fullWidth />
                </Grid>
                <Grid item xs={12} sm={5}>
                    <TextField
                        label="Phone"
                        fullWidth
                        placeholder="(123) 456-7890"
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label="Incident Circumstances"
                        fullWidth
                        multiline
                        rows={4}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}
